export default __webpack_public_path__ + "static/media/dolls_light.2ad80922.png";